import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Switch from "react-switch";

const DigiFormTogglePublicForm = ({
  value,
  onChange
}) => (
  <div>
    <hr />
    <label id="enable-attachments-custom-forms">Allow Public Submission</label>
    <br />
    <Switch
      checked={value}
      onChange={onChange}
      onColor="#DADCE1"
      onHandleColor="#3A4590"
      handleDiameter={25}
      uncheckedIcon={false}
      checkedIcon={false}
      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
      height={20}
      width={48}
      className="react-switch"
      name="public_form"
      aria-labelledby="enable-attachments-custom-forms"
    />
    <br />
  </div>
);

DigiFormTogglePublicForm.propType = {
  value: PropTypes.string,
  onChange: PropTypes.func
};

export default DigiFormTogglePublicForm;
